import React from "react";
import { ConnectedProps, connect } from "react-redux";
import "./index.css";
import { ReducerState } from "../../types";
import CatalogFilters from "../../components/CatalogFilters";
import Catalog from "../../components/Catalog";
import CatalogDownload from "../../components/CatalogDownload";
import { Typography } from "antd";

const { Title } = Typography;

const mapStateToProps = (state: ReducerState) => {
  return {
    selected: state.devices?.selected?.uuid || null,
  };
};

const connector = connect(mapStateToProps, {});

type Props = ConnectedProps<typeof connector> & {
  // Extra props go here
};

const ImageCatalog: React.FC<Props> = () => {
  return (
    <div className="mx-6 flex min-h-full pt-6 h-fit flex-col">
      <div className="flex justify-between w-full">
        <Title level={2}>Image Catalog</Title>
        <CatalogDownload />
      </div>
      <div className="flex-1 flex">
        <div className="max-w-100 h-full w-74">
          <CatalogFilters />
        </div>
        <div className="flex-1 ml-6">
          <Catalog />
        </div>
      </div>
    </div>
  );
};

export default connector(ImageCatalog);
